import clsx from "clsx";

interface Props {
    className?: string
    FillColor?: string
}

export default function Download({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" className={clsx(className, FillColor)}>
            <path
                d="M21 20.3C21 20.1343 20.8657 20 20.7 20H4.2C3.53726 20 3 20.5373 3 21.2C3 21.3657 3.13432 21.5 3.3 21.5H19.8C20.4627 21.5 21 20.9627 21 20.3Z"
                fill="black"/>
            <path
                d="M11.25 3.8C11.25 3.63431 11.3843 3.5 11.55 3.5C12.2127 3.5 12.75 4.03726 12.75 4.7V15.9333L17.2161 11.4309C17.3323 11.3137 17.5211 11.3114 17.6401 11.4257C18.1288 11.8949 18.1367 12.674 17.6577 13.153L12.8485 17.9622C12.3799 18.4308 11.6201 18.4308 11.1514 17.9622L6.31816 13.1289C5.84953 12.6603 5.84953 11.9005 6.31816 11.4319C6.43532 11.3147 6.62527 11.3147 6.74243 11.4319L11.25 15.9394V3.8Z"
                fill="black"/>
        </svg>
    )
}
